"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._rxjs@5.4.3@rxjs/util/isArrayLike.js
// module id = ../../../../._rxjs@5.4.3@rxjs/util/isArrayLike.js
// module chunks = 5